import {
	Checkbox,
	FormControlLabel,
	Grid,
	Input,
	InputLabel,
	Modal,
} from '@mui/material';

import React from 'react';

import AllUsers from './AllUsers';

import RoleManager from './RoleManager';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import { Link } from 'react-router-dom';

import AddIcon from '@mui/icons-material/Add';

import PropTypes from 'prop-types';

import Tabs from '@mui/material/Tabs';

import Tab from '@mui/material/Tab';

import Chip from '@mui/material/Chip';

import { Box, Button, Typography } from '@mui/material';

function CustomTabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box sx={{ p: 1 }}>
					<Typography>{children}</Typography>
				</Box>
			)}
		</div>
	);
}

CustomTabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.number.isRequired,
	value: PropTypes.number.isRequired,
};

function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		'aria-controls': `simple-tabpanel-${index}`,
	};
}

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: '60%',
	backgroundColor: 'white',
	border: ' 1px solid #00000026',
	p: 4,
	borderRadius: '10px',
};

function RolesPermission() {
	const defaultTheme = createTheme();
	const [value, setValue] = React.useState(0);

	const [open, setOpen] = React.useState(false);
	const handleOpen = () => setOpen(true);
	const handleCloseModal = () => {
		setOpen(false);
	};
	const handleChange = (event, newValue) => {
		setValue(newValue);
	};
	const gridItems = [
		{ label: 'Can View Charges', xs: 12, sm: 6, md: 4, lg: 4, xl: 4 },
		{ label: 'Can View Practices', xs: 12, sm: 6, md: 4, lg: 4, xl: 4 },
		{ label: 'Can View Patients', xs: 12, sm: 6, md: 4, lg: 4, xl: 4 },
		{ label: 'Can View Patients', xs: 12, sm: 6, md: 4, lg: 4, xl: 4 },
		{ label: 'Can View Patients', xs: 12, sm: 6, md: 4, lg: 4, xl: 4 },
		{ label: 'Can View Patients', xs: 12, sm: 6, md: 4, lg: 4, xl: 4 },
		{ label: 'Can View Patients', xs: 12, sm: 6, md: 4, lg: 4, xl: 4 },
		{ label: 'Can View Patients', xs: 12, sm: 6, md: 4, lg: 4, xl: 4 },
		{ label: 'Can View Patients', xs: 12, sm: 6, md: 4, lg: 4, xl: 4 },
		{ label: 'Can View Patients', xs: 12, sm: 6, md: 4, lg: 4, xl: 4 },
		{ label: 'Can View Patients', xs: 12, sm: 6, md: 4, lg: 4, xl: 4 },
		{ label: 'Can View Patients', xs: 12, sm: 6, md: 4, lg: 4, xl: 4 },
		{ label: 'Can View Patients', xs: 12, sm: 6, md: 4, lg: 4, xl: 4 },
		{ label: 'Can View Patients', xs: 12, sm: 6, md: 4, lg: 4, xl: 4 },
		{ label: 'Can View Patients', xs: 12, sm: 6, md: 4, lg: 4, xl: 4 },
	];

	return (
		<ThemeProvider theme={defaultTheme}>
			<Grid container xs={12} xl={12} lg={12} md={12} sm={12}>
				<Grid
					container
					item
					xs={12}
					xl={12}
					lg={12}
					md={12}
					sm={12}
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						boxShadow: '0px 1px 10px 0px #00000040',
						padding: '15px',
					}}
				>
					<Grid item>
						<Typography
							variant="body1"
							sx={{
								fontFamily: 'Poppins',
								fontSize: '19px',
								fontWeight: '500',
								color: 'black',
							}}
						>
							Your Users
						</Typography>
						<Typography
							variant="body2"
							sx={{
								fontFamily: 'Poppins',
								fontSize: '14px',
								fontWeight: '400',
								color: '#7E7171',
							}}
						>
							Invite or manage your organization&apos;s members
						</Typography>
					</Grid>
					<Grid item>
						<Button
							startIcon={<AddIcon />}
							onClick={handleOpen}
							sx={{
								background: '#e87511',
								color: 'white',
								borderRadius: '6px',
								fontFamily: 'Poppins',
								'&:hover': {
									color: '#e87511',
									boxShadow: '0px 3px 10px 0px #00000040',
									border: '0.5px solid #e87511',
								},
							}}
						>
							Add User
						</Button>
						<Modal
							open={open}
							onClose={handleCloseModal}
							aria-labelledby="modal-modal-title"
							aria-describedby="modal-modal-description"
						>
							<Box sx={style}>
								<Grid container lg={12} xs={12} md={12} sm={12}>
									<Grid
										item
										lg={12}
										xs={12}
										md={12}
										sm={12}
										xl={12}
										justifyContent="center"
									>
										<Typography
											variant="h5"
											sx={{
												fontFamily: 'Poppins',
												fontSize: '32px',
												fontWeight: '500',
												textAlign: 'center',
											}}
										>
											Add User
										</Typography>
									</Grid>
									<Grid
										item
										lg={6}
										xs={6}
										md={6}
										sm={6}
										sx={{ padding: '5px' }}
									>
										<InputLabel
											sx={{
												fontFamily: 'Poppins',
												fontSize: '14px',
												fontWeight: '500',
												textAlign: 'left',
												color: 'black',
											}}
										>
											User ID
										</InputLabel>
										<Input
											name="userID"
											type="number"
											placeholder="123"
											fullWidth
											disableUnderline
											sx={{
												border: '1px solid #00000026',
												boxShadow: ' 0px 1px 2px 0px #79ACF178 inset',
												borderRadius: '4px',
												padding: '6px 3px',
											}}
										/>
									</Grid>
									<Grid
										item
										lg={6}
										xs={6}
										xl={6}
										md={6}
										sm={6}
										sx={{ padding: '5px' }}
									>
										<InputLabel
											sx={{
												fontFamily: 'Poppins',
												fontSize: '14px',
												fontWeight: '500',
												textAlign: 'left',
												color: 'black',
											}}
										>
											Username
										</InputLabel>
										<Input
											name="username"
											type="text"
											placeholder="NIKI,JOHN"
											fullWidth
											disableUnderline
											sx={{
												border: '1px solid #00000026',
												boxShadow: ' 0px 1px 2px 0px #79ACF178 inset',
												borderRadius: '4px',
												padding: '6px 3px',
											}}
										/>
									</Grid>
									<Grid
										item
										container
										lg={12}
										xl={12}
										xs={12}
										md={12}
										sm={12}
										sx={{
											dislay: 'flex',
											justifyContent: 'space-between',
											paddingTop: '10px',
											paddingBottom: '10px',
										}}
									>
										<Grid item>
											<Typography
												variant="body1"
												sx={{
													fontFamily: 'Poppins',
													fontWeight: '500',
													fontSize: '19px',
												}}
											>
												User Roles
											</Typography>
										</Grid>
										<Grid item>
											<Button
												startIcon={<AddIcon />}
												sx={{
													background: 'white',
													color: '#257CFF',
													display: 'flex',
													alignItems: 'center',
												}}
											>
												Add Role
											</Button>
										</Grid>
									</Grid>
									<Grid item container lg={12} xs={12} xl={12} md={12} sm={12}>
										{gridItems.map((item, index) => (
											<Grid
												key={index}
												item
												xs={item.xs}
												sm={item.sm}
												md={item.md}
												lg={item.lg}
												xl={item.xl}
												sx={{
													display: 'flex',
													justifyContent: 'center',
												}}
											>
												<FormControlLabel
													control={<Checkbox />}
													label={item.label}
												/>
											</Grid>
										))}
									</Grid>
									<Grid
										item
										container
										lg={12}
										xs={12}
										md={12}
										sm={12}
										xl={12}
										justifyContent="center"
										sx={{ marginTop: '10px' }}
									>
										<Grid item lg={4} xs={4} md={4} sm={4} xl={4}>
											<Button
												onClick={handleCloseModal}
												fullWidth
												sx={{
													background: '#ED2828',
													color: 'white',
													marginRight: '5px',
													fontFamily: 'Poppins',
													fontSize: '16px',
													border: '2px solid #ED2828',
													fontWeight: '400',
													'&:hover': {
														color: '#ED2828',
														background: 'white',
														border: '2px solid #ED2828',
													},
												}}
											>
												Cancel
											</Button>
										</Grid>
										<Grid item lg={4} xs={4} md={4} sm={4} xl={4}>
											<Button
												fullWidth
												sx={{
													background: '#FD7702',
													border: '2px solid #FD7702',
													color: 'white',
													marginLeft: '5px',
													fontFamily: 'Poppins',
													fontSize: '16px',
													fontWeight: '400',
													'&:hover': {
														color: '#FD7702',
														background: 'white',
														border: '2px solid #FD7702',
													},
												}}
											>
												CREATE
											</Button>
										</Grid>
									</Grid>
								</Grid>
							</Box>
						</Modal>
					</Grid>
				</Grid>
				<Grid
					container
					item
					xs={12}
					xl={12}
					lg={12}
					md={12}
					sm={12}
					sx={{
						border: '1px solid #E3E0E0',
					}}
				>
					<Box sx={{ width: '100%' }}>
						<Box sx={{ borderColor: 'divider' }}>
							<Tabs
								value={value}
								onChange={handleChange}
								aria-label="basic tabs example"
							>
								<Tab
									sx={{
										fontFamily: 'Poppins',
										color: 'black',
										fontSize: '16px',
										fontWeight: '500',
										display: 'flex', // Added flex display
										alignItems: 'center',
										flexDirection: 'row',
										gap: 2,
									}}
									label={
										<React.Fragment>
											<span>All Users</span> <Chip label="5" />{' '}
										</React.Fragment>
									}
									{...a11yProps(0)}
								/>
								<Tab
									sx={{
										fontFamily: 'Poppins',
										color: 'black',
										fontSize: '16px',
										fontWeight: '500',
										paddingLeft: '25px',
										borderLeft: '1px solid #D7D7D7',
									}}
									label="Users Role Manager"
									{...a11yProps(1)}
								/>
							</Tabs>
						</Box>
						<CustomTabPanel value={value} index={0}>
							<AllUsers />
						</CustomTabPanel>
						<CustomTabPanel value={value} index={1}>
							<RoleManager />
						</CustomTabPanel>
					</Box>
				</Grid>
			</Grid>
		</ThemeProvider>
	);
}

export default RolesPermission;
